const regexPatterns: {
  allPrescription: RegExp
  prescriptionSunglasses: RegExp
  prescriptionEyeglasses: RegExp
  allPossibleLensTech: RegExp
  snowLensTech: RegExp
  sunglassesLensTech: RegExp
  polarisedLensTech: RegExp
  lensTechReplacementPatterns: Record<string, string>
  lensTechLookup: [RegExp, string][]
} = {
  allPrescription: /(le_STRX|le_STPRX|le_THRX|le_THPRX|le_RX|le_STCRX|le_THCRX|le_THBRX|le_STBRX)/,
  prescriptionSunglasses: /(le_STRX|le_STPRX|le_THRX|le_THPRX|le_RX)/,
  prescriptionEyeglasses: /(le_STCRXclear|le_THCRXclear|le_STBRXclear|le_THBRXclear|le_RXclear)/,
  allPossibleLensTech:
    /^([a-z0-9]+le_(?:[a-z0-9]+_)?)(8W|8PW|N|P|8P|8|STRX|STPRX|THRX|THPRX|RX|STCRX|THCRX|STBRX|THBRX)(IR)?([a-z]*)$/,
  snowLensTech: /(N|8N)$/g,
  sunglassesLensTech: /_(8W|8PW|P|N|8P|8|RX|STRX|STPRX|THRX|THPRX|STCRX|THCRX|STBRX|THBRX)/g,
  polarisedLensTech: /\b(4kop|8kop|thp|stp)/i,
  lensTechReplacementPatterns: {
    '4ko': '$1N$3$4',
    '4kop': '$1P$3$4',
    '8ko': '$18$3$4',
    '8kop': '$18P$3$4',
    st: '$1STRX$3$4',
    stp: '$1STPRX$3$4',
    th: '$1THRX$3$4',
    thp: '$1THPRX$3$4',
    stc: '$1STCRX$3$4',
    thc: '$1THCRX$3$4',
    stb: '$1STBRX$3$4',
    thb: '$1THBRX$3$4',
    '4kosnow': '$1N$3$4',
    '8kosnow': '$18N$3$4',
    '8kowater': '$18W$3$4',
    '8kopwater': '$18PW$3$4',
  },
  lensTechLookup: [
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?N[a-z0-9]*$/, '4ko'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?P[a-z0-9]*$/, '4kop'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?8(?!P|IR|W)[a-z0-9]*$/, '8ko'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?8P(?!W)[a-z0-9]*$/, '8kop'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?8IR[a-z0-9]*$/, 'iris'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?RXclear$/, 'rxclear'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?RX[a-z0-9]*$/, 'rx'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?STRX[a-z0-9]*$/, 'st'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?STPRX[a-z0-9]*$/, 'stp'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?THRX[a-z0-9]*$/, 'th'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?THPRX[a-z0-9]*$/, 'thp'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?STCRXclear$/, 'stc'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?STBRXclear$/, 'stb'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?THCRXclear$/, 'thc'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?THBRXclear$/, 'thb'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?8W[a-z0-9]*$/, '8kowater'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?8PW[a-z0-9]*$/, '8kopwater'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?[a-z0-9]*8N$/, '8kosnow'],
    [/[a-z0-9]+le_(?:[a-z0-9]+_)?[a-z0-9]*N$/, '4kosnow'],
  ],
}

export default regexPatterns
